import { createRemoteStore } from '@move-frontend/utils';
import { ILoaderMyVehicles } from '../use-cases/getVehiclesLoader';
import { IVehicle } from '../../../../shared/api/gateway/models/Vehicle';
import { setVehiclesAmount } from '../../shared/analytics/setVehiclesAmount';

export type MyVehicleStore = ReturnType<typeof createGetVehicleStores>;

export const createGetVehicleStores = (loadMyVehicles: ILoaderMyVehicles) =>
	createRemoteStore<void, IVehicle[]>({
		loader: async () => {
			const vehicles = await loadMyVehicles();

			setVehiclesAmount(vehicles);

			vehicles.sort((a, b) => a.description.localeCompare(b.description));

			return vehicles;
		},
	});
